import gql from 'graphql-tag'

export const EVENT_OF_CURRENT_DAY = gql`
  query Event($occurred_at: timestamp, $trackable_ids: [String!]){
    events(where: {occurred_at: {_gte: $occurred_at}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids} }, order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }

`

export const EVENT_OF_CURRENT_DAY_BY_VEHICLE = gql`
  query Event($occurred_at: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $occurred_at},
        event_description_id: {_eq: 1},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const ASCENDING_EVENT_OF_CURRENT_DAY_BY_VEHICLE = gql`
  query Event($occurred_at: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $occurred_at},
        event_description_id: {_eq: 1},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: asc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const EVENT_CREATED = gql`
  subscription ($occurred_at: timestamp, $trackable_ids: [String!]){
    events(limit: 1, where: {occurred_at: {_gte: $occurred_at}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids} }, order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const EVENT_CREATED_BY_VEHICLE = gql`
  subscription ($occurred_at: timestamp, $jsonFilter: jsonb){
    events(limit: 1,
      where: {
        occurred_at: {_gte: $occurred_at},
        event_description_id: {_eq: 1},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const EVENT_OF_SELECTED_DAY = gql`
  query Event($start: timestamp, $end: timestamp, $trackable_ids: [String!]){
    events(where: {occurred_at: {_gte: $start, _lte: $end}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids} }, order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const EVENT_OF_SELECTED_DAY_BY_VEHICLE = gql`
  query Event($start: timestamp, $end: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $start, _lte: $end},
        event_description_id: {_eq: 1},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const EVENT_OF_SELECTED_MONTH = gql`
  query Event($startMonth: timestamp, $endMonth: timestamp, $trackable_ids: [String!]){
    events(where: {occurred_at: {_gte: $startMonth, _lte: $endMonth}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids} }) {
      id
      occurred_at
      trackable_id
    }
  }
`

export const EVENT_OF_SELECTED_MONTH_BY_VEHICLE = gql`
  query Event($startMonth: timestamp, $endMonth: timestamp, $jsonFilter: jsonb) {
    events(where: {
      occurred_at: {_gte: $startMonth, _lte: $endMonth},
      event_description_id: {_eq: 1},
      metadata: {_contains: $jsonFilter}
    }) {
      id
      occurred_at
      trackable_id
    }
  }
`

export const EVENT_TO_CHECK_OF_CURRENT_DAY = gql`
  query Event($occurred_at: timestamp, $trackable_ids: [String!]){
    events(where: {occurred_at: {_gte: $occurred_at}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids} checked: {_eq: false}}, order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const EVENT_TO_CHECK_OF_CURRENT_DAY_BY_VEHICLE = gql`
  query Event($occurred_at: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $occurred_at},
        checked: {_eq: false},
        event_description_id: {_eq: 1},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const EVENT_TO_CHECK_OF_SELECTED_DAY = gql`
  query Event($start: timestamp, $end: timestamp, $trackable_ids: [String!]) {
    events(where: {occurred_at: {_gte: $start, _lte: $end}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids}, checked: {_eq: false}}, order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const EVENT_TO_CHECK_OF_SELECTED_DAY_BY_VEHICLE = gql`
  query Event($start: timestamp, $end: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $start, _lte: $end},
        checked: {_eq: false},
        event_description_id: {_eq: 1},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const EVENT_TO_CHECK_OF_SELECTED_MONTH = gql`
  query Event($startMonth: timestamp, $endMonth: timestamp, $trackable_ids: [String!]) {
    events(where: {occurred_at: {_gte: $startMonth, _lte: $endMonth}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids}, checked: {_eq: false}}) {
      id
      occurred_at
      trackable_id
    }
  }
`

export const EVENT_TO_CHECK_OF_SELECTED_MONTH_BY_VEHICLE = gql`
  query Event($startMonth: timestamp, $endMonth: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $startMonth, _lte: $endMonth},
        checked: {_eq: false},
        event_description_id: {_eq: 1},
        metadata: {_contains: $jsonFilter}
      }) {
      id
      occurred_at
      trackable_id
    }
  }
`

export const CHECKED_EVENT_OF_CURRENT_DAY = gql`
  query Event($occurred_at: timestamp, $trackable_ids: [String!]) {
    events(where: {occurred_at: {_gte: $occurred_at}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids}, has_ticket: {_eq: true}, checked: {_eq: true}, state: {_eq: "valid"}}, order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const CHECKED_EVENT_OF_CURRENT_DAY_BY_VEHICLE = gql`
  query Event($occurred_at: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $occurred_at},
        event_description_id: {_eq: 1},
        has_ticket: {_eq: true},
        checked: {_eq: true},
        state: {_eq: "valid"},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const CHECKED_EVENT_OF_SELECTED_DAY = gql`
  query Event($start: timestamp, $end: timestamp, $trackable_ids: [String!]) {
    events(where: {occurred_at: {_gte: $start, _lte: $end}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids}, has_ticket: {_eq: true}, checked: {_eq: true}, state: {_eq: "valid"}}, order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const CHECKED_EVENT_OF_SELECTED_DAY_BY_VEHICLE = gql`
  query Event($start: timestamp, $end: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $start, _lte: $end},
        event_description_id: {_eq: 1},
        has_ticket: {_eq: true},
        checked: {_eq: true},
        state: {_eq: "valid"},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const CHECKED_EVENT_OF_SELECTED_MONTH = gql`
  query Event($startMonth: timestamp, $endMonth: timestamp, $trackable_ids: [String!]) {
    events(where: {occurred_at: {_gte: $startMonth, _lte: $endMonth}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids}, has_ticket: {_eq: true}, checked: {_eq: true}, state: {_eq: "valid"}}) {
      id
      occurred_at
      trackable_id
    }
  }
`

export const CHECKED_EVENT_OF_SELECTED_MONTH_BY_VEHICLE = gql`
  query Event($startMonth: timestamp, $endMonth: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $startMonth, _lte: $endMonth},
        event_description_id: {_eq: 1},
        has_ticket: {_eq: true},
        checked: {_eq: true},
        state: {_eq: "valid"},
        metadata: {_contains: $jsonFilter}
      }) {
      id
      occurred_at
      trackable_id
    }
  }
`

export const OFFENSE_OF_CURRENT_DAY = gql`
  query Event($occurred_at: timestamp, $trackable_ids: [String!]) {
    events(where: {occurred_at: {_gte: $occurred_at}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids}, checked: {_eq: true}, state: {_eq: "invalid"}}, order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const OFFENSE_OF_CURRENT_DAY_BY_VEHICLE = gql`
  query Event($occurred_at: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $occurred_at},
        event_description_id: {_eq: 1},
        checked: {_eq: true},
        state: {_eq: "invalid"},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const OFFENSE_OF_SELECTED_DAY = gql`
  query Event($start: timestamp, $end: timestamp, $trackable_ids: [String!]) {
    events(where: {occurred_at: {_gte: $start, _lte: $end}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids}, checked: {_eq: true}, state: {_eq: "invalid"}}, order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const OFFENSE_OF_SELECTED_DAY_BY_VEHICLE = gql`
  query Event($start: timestamp, $end: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $start, _lte: $end},
        event_description_id: {_eq: 1},
        checked: {_eq: true},
        state: {_eq: "invalid"},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const OFFENSE_OF_SELECTED_MONTH = gql`
  query Event($startMonth: timestamp, $endMonth: timestamp, $trackable_ids: [String!]) {
    events(where: {occurred_at: {_gte: $startMonth, _lte: $endMonth}, event_description_id: {_eq: 1}, trackable_id: {_in: $trackable_ids}, checked: {_eq: true}, state: {_eq: "invalid"}}) {
      id
      occurred_at
      trackable_id
    }
  }
`

export const OFFENSE_OF_SELECTED_MONTH_BY_VEHICLE = gql`
  query Event($startMonth: timestamp, $endMonth: timestamp, $jsonFilter: jsonb) {
    events(where: {
        occurred_at: {_gte: $startMonth, _lte: $endMonth},
        event_description_id: {_eq: 1},
        checked: {_eq: true},
        state: {_eq: "invalid"},
        metadata: {_contains: $jsonFilter}
      }) {
      id
      occurred_at
      trackable_id
    }
  }
`

export const EVENT_SELECTED = gql`
  query Event($id: uuid) {
    events(where: {id: {_eq: $id}}) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const UPDATE_EVENT_SELECTED_TO_VALID_STATUS_WITH_VALUE = gql`
  mutation Event($id: uuid, $value: jsonb){
    update_events(
      where: {id: {_eq: $id}},
      _set: {state: "valid", checked: true, has_ticket: true},
      _append: {metadata: $value},
      ) {
      affected_rows
      returning {
        checked
        event_description {
          name
        }
        event_description_id
        gas_station
        has_ticket
        id
        initialized_at
        metadata
        occurred_at
        received_at
        state
        trackable_id
        value
      }
    }
  }
`

export const UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITH_VALUE = gql`
  mutation Event($id: uuid, $value: jsonb){
    update_events(
      where: {id: {_eq: $id}},
      _set: {state: "invalid", checked: true},
      _append: {metadata: $value},
      ) {
      affected_rows
      returning {
        checked
        event_description {
          name
        }
        event_description_id
        gas_station
        has_ticket
        id
        initialized_at
        metadata
        occurred_at
        received_at
        state
        trackable_id
        value
      }
    }
  }
`

export const UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITH_VALUE_AND_DELTA = gql`
  mutation Event($id: uuid, $value: jsonb){
    update_events(
      where: {id: {_eq: $id}},
      _set: {state: "invalid", checked: true, has_ticket: true},
      _append: {metadata: $value},
      ) {
      affected_rows
      returning {
        checked
        event_description {
          name
        }
        event_description_id
        gas_station
        has_ticket
        id
        initialized_at
        metadata
        occurred_at
        received_at
        state
        trackable_id
        value
      }
    }
  }
`

export const UPDATE_EVENT_SELECTED_TO_INVALID_STATUS_WITHOUT_VALUE = gql`
  mutation Event($id: uuid){
    update_events(
      where: {id: {_eq: $id}},
      _set: {state: "invalid", checked: true}
      ) {
      affected_rows
      returning {
        checked
        event_description {
          name
        }
        event_description_id
        gas_station
        has_ticket
        id
        initialized_at
        metadata
        occurred_at
        received_at
        state
        trackable_id
        value
      }
    }
  }
`

export const GET_EVENTS_BY_SELECTED_TICKET = gql`
  query Event($jsonFilter: jsonb, $trackable_ids: [String!]) {
    events(where: {
          state: {_eq: ""},
          event_description_id: {_eq: 1},
          trackable_id: {_in: $trackable_ids},
          metadata: {_contains: $jsonFilter}
        }
      ) {
      id
      occurred_at
      initialized_at
      received_at
      trackable_id
      metadata
      value
      has_ticket
      checked
      state
      gas_station
      event_description_id
      event_description {
        name
      }
    }
  }
`

export const LAST_THREE_EVENT = gql`
query getLastThreeEvent($trackable_ids: [String!], $occurred_at: timestamp){
    events(where: {
      event_description_id: {_eq: 1},
      trackable_id: {_in: $trackable_ids},
      occurred_at: {_gte: $occurred_at}
    },
    order_by: {occurred_at: desc},
    limit: 6) {
      occurred_at
      trackable_id
      metadata
      event_description {
        description
      }
    }
  }
`
export const LAST_THREE_EVENT_UPDATED = gql`
subscription getLastThreeEventSub($trackable_ids: [String!], $occurred_at: timestamp){
    events(where: {
      event_description_id: {_eq: 1},
      trackable_id: {_in: $trackable_ids},
      occurred_at: {_gte: $occurred_at}
    }, 
    order_by: {occurred_at: desc},
    limit: 6) {
      occurred_at
      trackable_id
      metadata
      event_description {
        description
      }
    }
  }
`

export const COUNT_CURRENT_EVENT = gql`
  query eventCount($occurred_at: timestamp, $trackable_ids: [String!]){
    events_aggregate(order_by: {
      occurred_at: desc},
      where: {
        occurred_at: {_gte: $occurred_at},
        event_description_id: {_eq: 1},
        trackable_id: {_in: $trackable_ids}
      }) {
      aggregate {
        count(columns: id)
      }
    }
  }
`
export const COUNT_CURRENT_EVENT_UPDATED = gql`
subscription eventCountSub($occurred_at: timestamp, $trackable_ids: [String!]){
    events_aggregate(order_by: {
      occurred_at: desc},
      where: {
        occurred_at: {_gte: $occurred_at},
        event_description_id: {_eq: 1},
        trackable_id: {_in: $trackable_ids}
      }) {
      aggregate {
        count(columns: id)
      }
    }
  }
`

export const COUNT_EVENT_OF_CURRENT_DAY_BY_VEHICLE = gql`
  query EventCountByVehicle($occurred_at: timestamp, $jsonFilter: jsonb) {
    events_aggregate(where: {
        occurred_at: {_gte: $occurred_at},
        event_description_id: {_eq: 1},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      aggregate {
        count(columns: id)
      }
    }
  }
`

export const COUNT_EVENT_OF_CURRENT_DAY_BY_VEHICLE_UPDATED = gql`
  subscription EventCountByVehicleUpdated($occurred_at: timestamp, $jsonFilter: jsonb) {
    events_aggregate(where: {
        occurred_at: {_gte: $occurred_at},
        event_description_id: {_eq: 1},
        metadata: {_contains: $jsonFilter}
      },
      order_by: {occurred_at: desc}) {
      aggregate {
        count(columns: id)
      }
    }
  }
`

export const REFUEL_EVENT = gql`
  query ($trackable_labels: [String!]!) {
    refuel_events(trackable_labels: $trackable_labels) {
      duration
      end_at
      end_volume
      event
      quantity
      start_at
      start_volume
      trackable_label
      registration_number
    }
  }
`

export const REFUEL_EVENT_BY_DATE = gql`
  query ($trackable_labels: [String!]!, $date: Date!) {
    refuel_events_by_date(trackable_labels: $trackable_labels, date: $date) {
      duration
      end_at
      end_volume
      event
      quantity
      start_at
      start_volume
      trackable_label
      registration_number
    }
  }
`

export const REFUEL_EVENT_DATE_BY_MONTH = gql`
  query ($trackable_labels: [String!]!, $month: String!, $year: String!) {
    refuel_events_dates_by_month(trackable_labels: $trackable_labels, month: $month, year: $year) {
      date
      trackable_label
    }
  }
`
